// TODO: API + UI refactor to ENUM relation GQL field
// f.e. stringValue -> STRING
// and remove this utility "fieldGenerator"
export const fieldGenerator = (type) => `${type.toLowerCase()}Value`

export const formAttributeObject = attr => {
  let value = attr.value[fieldGenerator(attr.type.type)]
  // for files or objects with id
  if (value !== null && value.id !== undefined) value = value.id
  return {
    type: attr.type.type,
    value,
    validationRules: attr?.type?.validationRules || []
  }
}
